module.exports = __webpack_public_path__ + "media/img/frontend_application/notification/venue_owner/review_received-a796254427381c4b4fe90213850d1c44.png";